import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material";
import Header from "../Header/Header";
import Workspace from "../Workspace/Workspace";
import Footer from "../Footer/Footer";
import { verifyTokenAsync } from "../../store/slices/authSlice";
import { useCartSync } from "../../hooks/useCartSync";
import { useFavoritesSync } from "../../hooks/useFavoritesSync";
import { useContextualData } from "../../hooks/useContextualData";

/**
 * Componente container principal da loja com layout responsivo.
 * Organiza e compõe os componentes Header, Workspace e Footer.
 * Container 100% responsivo com controle de overflow para mobile/desktop.
 * Verifica token de autenticação na inicialização.
 *
 * @component
 * @returns {JSX.Element} Layout principal responsivo da loja
 */
export default function Store() {
  const dispatch = useDispatch();
  const { user, isAuthenticated } = useSelector((state) => state.auth);
  const { loadRemoteCart } = useCartSync();
  const { loadRemoteFavorites } = useFavoritesSync();
  const { isDataLoaded } = useContextualData();

  useEffect(() => {
    // Verifica token apenas se há usuário no localStorage na inicialização
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      dispatch(verifyTokenAsync());
    }
  }, [dispatch]);

  useEffect(() => {
    // Carrega carrinho e favoritos quando usuário faz login
    if (isAuthenticated && user?.email) {
      loadRemoteCart();
      loadRemoteFavorites();
    }
  }, [isAuthenticated, user?.email, loadRemoteCart, loadRemoteFavorites]);

  return (
    <Box
      sx={{
        position: "relative",
        minHeight: "100vh",
        width: "100%",
        maxWidth: "100vw",
        overflowX: "hidden",
        backgroundColor: '#EEE9E9',
      }}
    >
      <Header />
      <Workspace />
      <Footer />
    </Box>
  );
}
